module.exports = __webpack_public_path__ + "img/coffee.8f6625b6.png";